import { Store } from 'pullstate'

export const OrgStore = new Store({
  isShouldUpdateOrgLog: false,
  isOrgListLoading: false,
  orgList: [],
  orgPage: 1,
  orgTotal: 0
})
